<template>

    <router-view></router-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import { Events as AuthEvents } from '@wittignl/js-core/plugins/Authentication'
    import getUrlParams from '@wittignl/js-core/utils/getUrlParams'

    @Component({

        name: 'app'
    })
    export default class extends Vue
    {
        mounted() {

            this.logger = this.$di.logger.child('App');

            this.$auth.on(AuthEvents.LOGOUT, this.onLogout.bind(this));

            this.checkForAccess();
        }

        onLogout(){

            this.logger.warn('Logged out, resetting Apollo store');

            this.$di.apollo.resetStore();
            this.$router.replace({ name: 'login' });
        }

        checkForAccess(){

            const urlParams = getUrlParams(window.location.search);
            if(!urlParams.access) {
                return;
            }

            const access = urlParams.access;
            if(access !== 'denied') {
                return;
            }

            this.$toast.error('Je hebt geen toegang tot deze applicatie');
        }
    }

</script>
